import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { UserSchema, UserService } from 'src/app/core';

@Injectable({ providedIn: 'root' })
export class UserResolver  {
  constructor(private userService: UserService) {}

  async resolve(): Promise<UserSchema | undefined> {
    try {
      return await this.userService.getUser();
    } catch (e) {
      return undefined;
    }
  }
}
